import styled from 'styled-components';

/**
 * User preview wrapper
 */
export const PreviewUserWrapper = styled.div`
  display: inline;
`;
